import { PhoneCountryConfig } from '../models/countryModel';

export const SV_FLAG =
  'https://storage.googleapis.com/assets-us-east4-propilatam-dev/website-assets/propi-web/el-salvador-flag.png';
export const GT_FLAG =
  'https://storage.googleapis.com/assets-us-east4-propilatam-dev/website-assets/propi-web/guatemala-flag.png';
export const PA_FLAG =
  'https://storage.googleapis.com/assets-us-east4-propilatam-dev/website-assets/propi-web/panama-flag.png';

export const SV = 'SV';
export const GT = 'GT';
export const PA = 'PA';

export const COUNTRY_PHONES_CONFIG: PhoneCountryConfig[] = [
  {
    code: SV,
    area_code: '+503',
    phone_length: 8,
  },
  {
    code: GT,
    area_code: '+502',
    phone_length: 8,
  },
  {
    code: PA,
    area_code: '+507',
    phone_length: 8,
  },
];

export const SV_CENTER = { lat: 13.67555049401088, lng: -89.23800587655418 };

export const GT_CENTER = {
  lat: 14.602933,
  lng: -90.5107544,
};

export const PA_CENTER = {
  lat: 8.983333,
  lng: -79.51667,
};
